import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AlertDialogComponent, AlertDialogModel } from '../alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { QuickRangeEvent } from '../date-quick-chips/date-quick-chips.component';

export interface JobOrderDataStatesFilters {
  fileName: string;
  date: string;
  fromDate: Date;
  toDate: Date;
}

enum DateFilterEnum {
  NONE = 'NONE',
  CUSTOM = 'CUSTOM',
}

@Component({
  selector: 'app-job-order-data-state-filter-component',
  templateUrl: './job-order-data-state-filter.component.html',
  styleUrls: ['./job-order-data-state-filter.component.scss'],
})
export class JobOrderDataStateFilterComponent implements OnInit {
  @Output()
  apply: EventEmitter<JobOrderDataStatesFilters> = new EventEmitter();

  @Output()
  viewAllSelected: EventEmitter<void> = new EventEmitter();

  formGroup = new FormGroup({
    fileName: new FormControl(''),
    date: new FormControl(DateFilterEnum.NONE),
    fromDate: new FormControl({ value: '', disabled: true }),
    toDate: new FormControl({ value: '', disabled: true }),
  });

  activeChip: string | null = null;

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {}

  applyQuickRange({ key, from, to }: QuickRangeEvent): void {
    this.activeChip = key;
    this.formGroup.controls.fromDate.reset({ value: from, disabled: false });
    this.formGroup.controls.toDate.reset({ value: to, disabled: false });
    this.formGroup.controls.date.setValue(DateFilterEnum.CUSTOM);

    this.apply.emit({
      ...this.formGroup.value,
      fromDate: from,
      toDate: to,
    });
  }

  onChange() {
    this.activeChip = null;
    switch (this.formGroup.value.date) {
      case 'CUSTOM': {
        // Enable custom date selection fields
        this.formGroup.controls.fromDate.reset({
          value: this.formGroup.value.fromDate,
          disabled: false,
        });
        this.formGroup.controls.toDate.reset({
          value: this.formGroup.value.toDate,
          disabled: false,
        });
        break;
      }
      default: {
        this.formGroup.controls.fromDate.reset({ value: null, disabled: true });
        this.formGroup.controls.toDate.reset({ value: null, disabled: true });
      }
    }
  }

  onApply() {
    const fromDate = this.formGroup.value.fromDate;
    const toDate = this.formGroup.value.toDate;
    if (this.formGroup.value.date === 'CUSTOM' && (fromDate === undefined || toDate === undefined)) {
      const dialogData = new AlertDialogModel(
        'Error during filter application',
        'Please, fill both date fields in order to apply filters'
      );
      this.dialog.open(AlertDialogComponent, { data: dialogData });
      return;
    }
    this.apply.emit({ ...this.formGroup.value, fromDate, toDate });
  }

  onViewAllSelected() {
    this.viewAllSelected.emit();
  }
}
